const LOADING_TIMEOUT = 10000;

export {LOADING_TIMEOUT};